<script setup lang="ts">
import { computed } from "vue";

import TypeDot from "@/components/ui/TypeDot/TypeDot.vue";
import { useSearchMenuStore } from "@/store/search/searchMenu";

const selection = computed(() => useSearchMenuStore().selectedStatusItems);
</script>

<template>
  {{ $t("general.statuses") }}
  <div v-for="status in selection" :key="status.id" class="shortcut">
    <TypeDot :color="status.color" />
    {{ status.name }}
  </div>
</template>
